// @ts-check
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import { RuleFormValues } from './types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  fetchData: () => Promise<any>,
  deleteRule: (ruleId: string) => Promise<any>,
  updateRule: (ruleId: string, formValues: RuleFormValues) => Promise<any>,
  createRule: (formValues: RuleFormValues) => Promise<any>
}} ActionsType */

/**
 * @param {string} apiPrefix
 * @returns {ActionsType}
 */
function buildActions(apiPrefix) {
  return {
    fetchData() {
      return api.get(`${apiPrefix}/edit`).then(response => response.data);
    },

    deleteRule(ruleId) {
      return api.delete(`${apiPrefix}/rules/${ruleId}`);
    },

    updateRule(ruleId, formValues) {
      return api
        .put(`${apiPrefix}/rules/${ruleId}`, { rule: decamelizeKeys(formValues) })
        .then(response => response.data.rule);
    },

    createRule(formValues) {
      return api
        .post(`${apiPrefix}/rules`, { rule: decamelizeKeys(formValues) })
        .then(response => response.data.rule);
    },
  };
}

export default buildActions;
